<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item>平台管理</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <layout-panel :collapse="false">
      <template slot="header">搜索</template>
      <el-form :model="search"
               :rules="searchRules"
               ref="searchForm"
               label-width="96px"
               label-position="right"
               size="medium"
               @submit.native.prevent="onSearch()">
        <div class="re-el-form__flex">
          <el-form-item label="申请人"
                        prop="id">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入申请人名称搜索"
              v-model="search.initiator"
              :query-request="getPlatformUsersIndex"
              :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
          <el-form-item label="申请状态"
                        prop="status">
            <el-select v-model="search.status"
                       class="width-max"
                       clearable
                       placeholder="请选择">
              <el-option
                v-for="item in options.status"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="修改账号"
                        prop="id">
            <remote-select
              class="width-max"
              clearable
              id-key="id"
              keyword-key="name"
              label-key="name"
              value-key="id"
              placeholder="请输入修改账号名称搜索"
              v-model="search.admin_id"
              :query-request="getPlatformUsersIndex"
              :find-request="getPlatformUsersDetail">
            </remote-select>
          </el-form-item>
        </div>
        <el-form-item>
          <el-button type="primary"
                     icon="el-icon-search"
                     native-type="submit">搜索
          </el-button>
          <el-button icon="sj-icon-export"
                     @click="onExportSearch()">导出
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    <layout-panel>
      <template slot="header">列表</template>
      <template slot="tools">
        <el-button type="primary"
                   size="small"
                   icon="el-icon-refresh"
                   @click="onRefresh()"></el-button>
      </template>
      <div class="margin b15">
        <!--添加-->
        <permission-apply-form></permission-apply-form>
        <el-button type="success"
                   size="mini"
                   @click="onBatchPass()">批量通过
        </el-button>
      </div>
      <el-table :data="table"
                stripe
                highlight-current-row
                border
                style="width: 100%"
                @selection-change="handleSelectionChange">
        <el-table-column
          type="selection"
          width="55">
        </el-table-column>
        <el-table-column prop="id"
                         label="申请ID"
                         min-width="40"></el-table-column>
        <el-table-column prop="initiator_name"
                         label="申请人"
                         min-width="70"></el-table-column>
        <el-table-column prop="admin_id_name"
                         label="修改账号"
                         min-width="70"></el-table-column>
        <el-table-column prop="customer_name"
                         label="客户资源"
                         min-width="200"></el-table-column>
        <el-table-column prop="status"
                         label="申请状态"
                         min-width="50">
          <template slot-scope="scope">
          <span v-for="item in options.status"
                v-if="scope.row.status === item.value">{{item.label}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="created_at"
                         label="申请时间"
                         width="160"></el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         width="200">
          <template slot-scope="scope">
            <div class="button-gutter">
              <el-button v-if="scope.row.status === 1" type="success"
                         size="mini"
                         @click="onPass(scope.row.id)">通过
              </el-button>
              <el-button  v-if="scope.row.status === 1" type="danger"
                         size="mini"
                         @click="onNotPass(scope.row.id)">不通过
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination background
                       @size-change="handleSizePageChange"
                       @current-change="handleCurrentPageChange"
                       :current-page="pagination.current_page"
                       :page-sizes="[20, 50, 100, 200]"
                       :page-size="pagination.per_page"
                       layout="total, sizes, prev, pager, next, jumper"
                       :total="pagination.total">
        </el-pagination>
      </div>
    </layout-panel>
  </div>
</template>

<script>
import { searchRules } from '../permission-apply.rules.js'
import dateTimePicker from '@core/mixins/dateTimePicker'
import table from '@core/mixins/table'
import PermissionApplyForm from '@/views/permission-apply/components/PermissionApplyForm'
import selectRemote from '@core/mixins/selectRemote'

export default {
  mixins: [table, dateTimePicker, selectRemote],
  components: {PermissionApplyForm},
  data () {
    return {
      searchRules,
      multipleSelection: [],
      search: {
        admin_id: null,
        initiator: null,
        status: null,
      },
      exportHeader: [
        {
          key: 'id',
          text: '申请ID',
        },
        {
          key: 'initiator_name',
          text: '申请人',
        },
        {
          key: 'admin_id_name',
          text: '修改账号',
        },
        {
          key: 'customer_name',
          text: '客户资源',
        },
        {
          key: 'status',
          text: '申请状态',
        },
        {
          key: 'created_at',
          text: '添加日期',
        },
      ],
    }
  },
  computed: Vuex.mapState({
    options: state => state.permissionApply.options,
  }),
  created () {},
  methods: {
    ...Vuex.mapActions(['getPlatformUsersIndex', 'getPlatformUsersDetail']),
    ...request.map([]),
    /**
     * 获得表格数据
     * @param {*} params
     */
    getTableData (params) {
      if (this.search.status) {
        this.search.status = Number(this.search.status)
      }
      return request.page('getPermissionApplyTable', params)
    },
    onExportPage () {
      this.$export(`${this.$route.meta.title}-${this.pagination.current_page}P`, this.table, {
        fileHeader: this.exportHeader,
      })
    },
    onExportSearch () {
      this.$export(this.$route.meta.title, {
        fileHeader: this.exportHeader,
        total: this.pagination.total,
        request: this.getTableData,
        requestParams: this.search,
        getResponseData: (data) => {
          data.data = this.handleExportData(data.data)
          return data
        }
      })
    },
    handleExportData (data) {
      data.forEach((row) => {
        this.options.status.forEach((status) => {
          if (status.value === row.status) {
            row.status = status.label
          }
        })
      })
      return data
    },
    onExportRows (id) {
      this.$export(this.$route.meta.title, {
        type: 'array',
        request: (params) => request('exportPermissionApplyData', params),
        requestParams: {id},
        getResponseData (data) {
          // 导出大于一页时去掉标题行
          data.current_page > 1 && data.data.splice(0, 1)
          return data
        },
      })
    },
    handleSelectionChange (val, index) {
      this.multipleSelection = val
    },
    checkMultipleSelectionIdsStatus () {
      let seletedStatus = this.multipleSelection.map(function (item) {
        return item.status
      })

      let checkStatus = true
      seletedStatus.forEach(function (item) {
        if (item !== 1) {
          checkStatus = false
        }
      })
      return checkStatus
    },
    onBatchPass () {
      let multipleIds = this.multipleSelection.map(item => item.id)
      let checkStatus = this.checkMultipleSelectionIdsStatus()
      if (checkStatus) {
        this.$confirm('此操作将批量通过该申请, 是否继续?', '提示', {type: 'warning'}).then(() => {
          request.common('batchPassPermissionApplyData', {apply_ids: multipleIds}).then((res) => {
            this.$router.go(0)
          })
        }).catch(() => {
          this.$message.info('已取消操作')
        })
      } else {
        this.$message.info('您勾选的申请非待审批状态，不可通过')
      }
    },
    onPass (id) {
      this.$confirm('此操作将通过该申请, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('passPermissionApplyData', {id: id}).then((res) => {
          this.$router.go(0)
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
    onNotPass (id) {
      this.$confirm('此操作将不通过该申请, 是否继续?', '提示', {type: 'warning'}).then(() => {
        request.common('failPassPermissionApplyData', {id: id}).then(() => {
          this.$router.go(0)
        })
      }).catch(() => {
        this.$message.info('已取消操作')
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
.col-center {
  text-align:center
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/permission-apply/pages/PermissionApplyTable.vue